<script>
  import { fade } from 'svelte/transition';

  export let feedbackMessage;
</script>

{#if feedbackMessage}
  <!-- Message -->
  <h3
    class="absolute w-full bottom-0 mb-10 text-center z-10 text-4xl font-bold opacity-50"
    in:fade="{{ delay: 1500, duration: 1000 }}">
    {feedbackMessage}
  </h3>
{/if}
